import { Link } from 'react-router-dom';
import { Page, Section, Stack } from '@/components/layout';
import { DisplayTitle, Eyebrow, Prose } from '@/components/typography';
import { GoldLine } from '@/components/ornaments';
import { CtaButton } from '@/components/ui';
import { EVENTS, formatDateRangeShort } from '@/features/events';
import styles from './UnderConstruction.module.css';

/** 404 propia: no es una pantalla de error de libreria, es parte del sitio. */
export function NotFoundPage() {
  return (
    <Page
      documentTitle="Página no encontrada"
      description="Esta dirección no existe en la web de la Gira 2027. Aquí tienes los cinco destinos."
    >
      <Section spacing="default" background="surface" labelledBy="titulo-404">
        <Stack gap="lg" align="start">
          <Eyebrow withSparkles ink="gold">
            Error 404
          </Eyebrow>
          <DisplayTitle id="titulo-404" level={1} size="lg">
            Esta página no existe
          </DisplayTitle>
          <GoldLine ornament="diamond" width="sm" />
          <Prose>
            <p>
              La dirección que has abierto no forma parte de la gira. Puede que el enlace esté mal escrito o
              que la página se haya movido. Estos son los cinco destinos:
            </p>
          </Prose>
          <ul className={styles.list} role="list">
            {EVENTS.map((event) => (
              <li key={event.slug}>
                <Link className={styles.item} to={event.path}>
                  <span className={styles.itemCity}>
                    <span aria-hidden="true">{event.flag}</span> {event.city}
                  </span>
                  <span className={styles.itemDate}>{formatDateRangeShort(event)}</span>
                </Link>
              </li>
            ))}
          </ul>
          <CtaButton as="internal" to="/" variant="primary" size="md">
            Volver a la gira
          </CtaButton>
        </Stack>
      </Section>
    </Page>
  );
}
